import enums from './enums';

export const depotAndFactoryStatuses = [
  { value: true, text: 'aktív' },
  { value: false, text: 'inaktív' }
];

export const translatedOrderStatuses = [
  { value: enums.orderStatus.new, text: 'új' },
  { value: enums.orderStatus.invalid, text: 'nem feldolgozható' },
  { value: enums.orderStatus.waitingForProcessing, text: 'feldolgozásra vár' },
  { value: enums.orderStatus.processing, text: 'feldolgozás alatt' },
  { value: enums.orderStatus.processed, text: 'feldolgozott' },
  { value: enums.orderStatus.partial, text: 'törtfuvar' },
  { value: enums.orderStatus.partiallyShipped, text: 'részben kiszállítva' },
  { value: enums.orderStatus.shipped, text: 'kiszállítva' },
  { value: enums.orderStatus.closed, text: 'lezárva' }
];

export const translatedFreightStatuses = [
  { value: enums.freightStatus.new, text: 'új' },
  { value: enums.freightStatus.scheduled, text: 'rögzítve' },
  { value: enums.freightStatus.published, text: 'kiajánlva' },
  { value: enums.freightStatus.accepted, text: 'elfogadva' },
  { value: enums.freightStatus.finalized, text: 'lehívva' },
  { value: enums.freightStatus.reserved, text: 'foglalva' },
  { value: enums.freightStatus.arrived, text: 'megérkezett' },
  { value: enums.freightStatus.delivery, text: 'kiszállítás alatt' },
  { value: enums.freightStatus.shipped, text: 'kiszállítva' },
  { value: enums.freightStatus.billed, text: 'számlázva' },
  { value: enums.freightStatus.finished, text: 'befejezve' },
  { value: enums.freightStatus.cancelled, text: 'lemondva' }
];

export const translatedPickupStatuses = [
  { value: enums.pickupStatus.new, text: 'új' },
  { value: enums.pickupStatus.scheduled, text: 'rögzítve' },
  { value: enums.pickupStatus.reserved, text: 'foglalva' },
  { value: enums.pickupStatus.arrived, text: 'megérkezett' },
  { value: enums.pickupStatus.shipped, text: 'átvéve' },
  { value: enums.pickupStatus.cancelled, text: 'lemondva' }
];

export const translatedTransporterStatuses = [
  { value: enums.transporterStatus.active, text: 'aktív' },
  { value: enums.transporterStatus.inactive, text: 'inaktív' }
];

export const translatedOfferStatuses = [
  { value: enums.offerStatus.sent, text: 'ajánlatkérő elküldve' },
  { value: enums.offerStatus.received, text: 'ajánlat beérkezett' },
  {
    value: enums.offerStatus.rejectedByTransporter,
    text: 'ajánlatkérés elutasítva'
  },
  { value: enums.offerStatus.accepted, text: 'ajánlat elfogadva' },
  { value: enums.offerStatus.rejected, text: 'ajánlat elutasítva' }
];

export const translatedOfferStatusesWithoutTender = [
  { value: enums.offerStatus.sent, text: 'megbízás elküldve' },
  { value: enums.offerStatus.received, text: 'megbízás jóváhagyásra vár' },
  {
    value: enums.offerStatus.rejectedByTransporter,
    text: 'megbízás elutasítva'
  },
  { value: enums.offerStatus.accepted, text: 'megbízás elfogadva' },
  { value: enums.offerStatus.rejected, text: 'megbízás elutasítva' }
];

export const translatedOfferStatusesForTransporters = [
  { value: enums.offerStatus.sent, text: 'ajánlat beérkezett' },
  { value: enums.offerStatus.received, text: 'ajánlat elküldve' },
  {
    value: enums.offerStatus.rejectedByTransporter,
    text: 'ajánlatkérés elutasítva'
  },
  { value: enums.offerStatus.accepted, text: 'ajánlat elfogadva' },
  { value: enums.offerStatus.rejected, text: 'ajánlat elutasítva' }
];

export const translatedOfferStatusesForTransportersWithoutTender = [
  { value: enums.offerStatus.sent, text: 'megbízás beérkezett' },
  { value: enums.offerStatus.received, text: 'megbízás jóváhagyásra vár' },
  {
    value: enums.offerStatus.rejectedByTransporter,
    text: 'megbízás elutasítva'
  },
  { value: enums.offerStatus.accepted, text: 'megbízás elfogadva' },
  { value: enums.offerStatus.rejected, text: 'megbízás elutasítva' }
];

export const translatedVehicleStatuses = [
  { value: enums.vehicleStatus.active, text: 'aktív' },
  { value: enums.vehicleStatus.inactive, text: 'inaktív' }
];

export const getOrderStatusText = (value: string): string =>
  translatedOrderStatuses.find((ts) => ts.value === value)?.text || '';

export const getFreightStatusText = (value: string): string =>
  translatedFreightStatuses.find((ts) => ts.value === value)?.text || '';

export const getPickupStatusText = (value: string): string =>
  translatedPickupStatuses.find((ts) => ts.value === value)?.text || '';

export const getTransporterStatusText = (value: string): string =>
  translatedTransporterStatuses.find((ts) => ts.value === value)?.text || '';

export const getOfferStatusText = (value: string): string =>
  translatedOfferStatuses.find((ts) => ts.value === value)?.text || '';

export const getOfferStatusWithoutTenderText = (value: string): string =>
  translatedOfferStatusesWithoutTender.find((ts) => ts.value === value)?.text || '';

export const getOfferStatusForTransporterText = (value: string): string =>
  translatedOfferStatusesForTransporters.find((ts) => ts.value === value)?.text || '';

export const getOfferStatusForTransporterWithoutTenderText = (value: string): string =>
  translatedOfferStatusesForTransportersWithoutTender.find((ts) => ts.value === value)?.text || '';

export const getPreferredTrucksText = (preferredTrucks: string[]): string => {
  if (!Array.isArray(preferredTrucks) || preferredTrucks.length === 0) {
    return '';
  }

  return preferredTrucks.join(', ');
};

export const getDepotAndFactoryStatusText = (value: boolean): string =>
  depotAndFactoryStatuses.find((ts) => ts.value === value)?.text || '';

type LoadPercentages = {
  kg: number;
  pallet: number;
  cargoSpace: number;
};

export const getLoadPercentagesText = (loadPercentages: LoadPercentages): string => {
  if (!loadPercentages) {
    return '';
  }

  return `súly: ${Math.round(loadPercentages.kg)}%, raklap szám: ${Math.round(
    loadPercentages.pallet
  )}%, raktér: ${Math.round(loadPercentages.cargoSpace)}%`;
};
